import { useCallback, useMemo } from 'react';

import { UserType } from '@enums/index';

import { useLazyGetMenteeAcademicsQuery, useLazyGetMentorAcademicsQuery } from '../api/academics';
import { AcademicsResponse } from '../types';

interface GetAcademicsProps {
    userType: UserType;
}

export default function useGetAcademics({ userType }: GetAcademicsProps) {
    const [getMentorAcademics, { data: mentorAcademicsData, isLoading: mentorLoading }] =
        useLazyGetMentorAcademicsQuery();
    const [getMenteeAcademics, { data: menteeAcademicsData, isLoading: menteeLoading }] =
        useLazyGetMenteeAcademicsQuery();

    const isLoading = useMemo(() => mentorLoading || menteeLoading, [mentorLoading, menteeLoading]);

    const education = useMemo(
        () => mentorAcademicsData || menteeAcademicsData,
        [mentorAcademicsData, menteeAcademicsData]
    );

    const getAcademics = useCallback(
        (username: string) => {
            let experiencesData: AcademicsResponse;
            switch (userType) {
                case UserType.Mentor:
                    getMentorAcademics({ username });
                    break;
                case UserType.Mentee:
                    getMenteeAcademics({ username });
                    break;
                default:
                    break;
            }
            return experiencesData!;
        },
        [userType, getMentorAcademics, getMenteeAcademics]
    );
    return {
        getAcademics,
        isLoading,
        education,
    };
}
